import { render } from "./SpinnerButton.vue?vue&type=template&id=f62e651a"
import script from "./SpinnerButton.vue?vue&type=script&lang=js"
export * from "./SpinnerButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__